import React, { useState } from "react";
import { Row, Col, Nav, Tab } from "react-bootstrap";
import DashboardLayout from "../DashboardLayout";
import InviteForm from "./InviteForm";
import TeamMembersList from "./TeamMembersList";
import InvitesList from "./InvitesList";

function TeamManagement({ user }) {
  const [activeTab, setActiveTab] = useState("members");

  // Only show team management to super admins
  if (user?.role !== "super_admin") {
    return (
      <DashboardLayout user={user}>
        <div style={{ padding: "20px" }}>
          <p>You don't have permission to access team management.</p>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout user={user}>
      <div className="bg-white p-4 rounded-lg shadow-sm" style={{ padding: "20px" }}>
        <h1 className="h3 mb-4">Team Management</h1>

        <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
          <Nav variant="tabs" className="mb-4 ps-0">
            <Nav.Item> 
              <Nav.Link eventKey="members">Team Members</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="invites">Pending Invites</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="members">
              <Row>
                <Col lg={8}>
                  <TeamMembersList user={user} />
                </Col>
                <Col lg={4}>
                  <InviteForm user={user} />
                </Col>
              </Row>
            </Tab.Pane>
            <Tab.Pane eventKey="invites">
              <Row>
                <Col lg={12}>
                  <InvitesList user={user} />
                </Col>
              </Row>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </DashboardLayout>
  );
}

export default TeamManagement;

